import React, { Component } from 'react'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import CustomLabelCreateForm from '../partials/CustomLabelCreateForm'

interface Props {}

export default class CustomLabelCreate extends Component<Props> {
  render () {
    return (
      <ContentLayout>
        <ContentMain layout="twoThird">
          <CustomLabelCreateForm />
        </ContentMain>
      </ContentLayout>
    )
  }
}
